<template>
  <div class="my_nav bc_0983CC site_min_w">

    <div class="site_content d_flex justify_content_sb c_fff fz16">

      <div class="content_w">
        <el-menu mode="horizontal" style="border: 0" router>
          <MenuNav :menus="siteInfo.nodes" exclude="problem"/>
        </el-menu>
      </div>

    </div>
  </div>
</template>

<script>
import MenuNav from '@/components/base/MenuNav.vue'

import { mapGetters } from 'vuex'
export default {
  components: {
    MenuNav
  },
  computed: {
    ...mapGetters(['siteInfo'])
  }

}
</script>

<style lang="scss" scoped>
.my_nav{
    min-height: 56px;
    .span_1{
      margin: 0 0 0 10px;
    }
    .div_1{
      padding: 22px 30px;
      color: rgba($color: #fff, $alpha: .9);
      &:hover{
        background: #0772B2;
      }
    }
    .content_w{
      width: 100%;
    }

    ::v-deep .el-menu-item, ::v-deep .el-submenu__title{
      background-color: var(--bgColor);
    }
}
</style>
